import { createContext, useContext } from 'react';

export const THEME_STORAGE_KEY = 'xinghuo-admin-theme-mode-v2';

export const normalizeThemeMode = (mode) => (mode === 'light' ? 'light' : 'dark');

export const getInitialThemeMode = () => {
  try {
    const storedMode = window.localStorage.getItem(THEME_STORAGE_KEY);
    return storedMode ? normalizeThemeMode(storedMode) : 'light';
  } catch {
    return 'light';
  }
};

export const applyThemeMode = (mode) => {
  const safeMode = normalizeThemeMode(mode);
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', safeMode);
    document.body?.setAttribute('data-theme', safeMode);
  }
};

export const freezeThemeSwitchMotion = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const root = document.documentElement;
  const body = document.body;
  root.classList.add('theme-switching');
  body?.classList.add('theme-switching');

  window.clearTimeout(window.__xinghuoThemeSwitchTimer);
  window.__xinghuoThemeSwitchTimer = window.setTimeout(() => {
    root.classList.remove('theme-switching');
    body?.classList.remove('theme-switching');
  }, 180);
};

export const ThemeModeContext = createContext({
  themeMode: 'light',
  isDark: false,
  setThemeMode: () => {},
  toggleThemeMode: () => {},
});

export const useThemeMode = () => useContext(ThemeModeContext);
